import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import {
  BillShareVm,
  BillTotalsVm,
} from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import {
  formatMoneyCompact,
  formatMoneyCompactList,
} from '@/features/dashboard/bookingChanges/utils/formatters.ts';

/**
 * „1 960 z 3 640 zł" — udział uczestnika w wartości rezerwacji.
 *
 * Symbol waluty pomijamy po lewej stronie tylko przy rezerwacji jednowalutowej;
 * gdy w grę wchodzą dwie waluty, każda liczba musi powiedzieć, o którą chodzi.
 */
export const formatShare = (share: BillShareVm): string => {
  const single =
    share.participantAmount.length === 1 && share.bookingAmount.length === 1;
  const participant = single
    ? formatMoneyCompact(share.participantAmount[0], false)
    : formatMoneyCompactList(share.participantAmount);

  return `${participant} z ${formatMoneyCompactList(share.bookingAmount)}`;
};

/**
 * Podgląd pokazuje ostatni zatwierdzony stan, szkic — stan po zmianie. Ta sama
 * reguła rządzi sumą i udziałem, więc obie stoją tu obok siebie.
 */
export const getParticipantTotal = (
  totals: BillTotalsVm,
  isEditing: boolean,
): MoneyValueDto[] => (isEditing ? totals.after : totals.before);

export const getShare = (
  totals: BillTotalsVm,
  isEditing: boolean,
): BillShareVm => (isEditing ? totals.share : totals.shareBefore);

/** W szkicu suma dostaje inny podpis, bo nie jest już kwotą obowiązującą. */
export const getParticipantTotalLabel = (isEditing: boolean): string =>
  isEditing ? 'Suma za uczestnika po zmianie' : 'Suma za uczestnika';
